import { createContext } from 'react';
const TemplateTwilioContext = createContext();
export default TemplateTwilioContext;
